<template>
  <v-container class="py-0 px-6">
        <!-- <v-row>
          <v-spacer></v-spacer>
            <v-btn
            small
            height="30px"
            color="primary"
            depressed
            class="px-2 ml-2"
            >Resultados</v-btn>
             <v-btn
            small
            height="30px"
            color="primary"
            depressed
            class="px-2 ml-2"
            >DAC</v-btn>
        </v-row> -->
    <v-row class="px-0 py-0 pr-2">
      <v-col class="py-0" cols="6">
         <h1>Dados do pagamento <br>{{ dadosPagamento.data_pagamento | formatData}}</h1>
            <!-- <p class="mb-0"><b>{{ dadosPagamento.prest_nome }} <br>{{ dadosPagamento.oper_nome }}</b></p> -->
    </v-col>
    <v-col class="text-right" style="display: grid;" cols="6">
      <b style="font-weight: 400" v-if="dadosPagamento && dadosPagamento.data_evento_atual">Atualizado: <span style="font-weight: 700">{{ dadosPagamento.data_evento_atual | formatDateHour}}</span></b>
      <b style="font-weight: 400" v-if="dadosPagamento && dadosPagamento.data_primeira_publicacao">Primeira publicação: <span style="font-weight: 700">{{ dadosPagamento.data_primeira_publicacao | formatDateHour}}</span></b>
    </v-col>
    <v-spacer></v-spacer>
    <v-tooltip v-if="!!dadosPagamento.doc_id_resultado" bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon
            class="mr-2 mt-2" 
            color="primary" 
            v-bind="attrs" 
            v-on="on"
            @click="getDocument({doc_id: dadosPagamento.doc_id_resultado, nome: 'Resultados'})"
          ><v-icon medium>fa-file-invoice</v-icon>
          </v-btn>
        </template>
        <span
          class="px-3 py-1 ma-0"
          style="border: solid 1px #999; border-radius: 5px; background-color: #FFF"
          >Resultados</span
        >
      </v-tooltip>
        <v-tooltip v-if="!!dadosPagamento.doc_id_dac" bottom >
        <template v-slot:activator="{ on, attrs }">
          <v-btn 
            icon
            class="mr-3 mt-2" 
            color="primary" 
            v-bind="attrs" 
            v-on="on"
            @click="getDocument({doc_id: dadosPagamento.doc_id_dac, nome: 'Análise de Contas'})"
          ><v-icon medium>fa-file-archive</v-icon>
          </v-btn>
        </template>
        <span
          class="px-3 py-1 ma-0"
          style="border: solid 1px #999; border-radius: 5px; background-color: #FFF"
          >DAC - Demonstrativo de Análise de Contas</span
        >
      </v-tooltip>
    </v-row>
    <v-row class="px-0 py-0">
      <v-col class="py-0" cols="12">
        <PagamentoInfo :info="dadosPagamento" />
        <v-divider></v-divider>
      </v-col>
    </v-row>
      <v-tabs v-model="tab" class="elevation-0">
        <v-tabs-slider></v-tabs-slider>
        <v-tab href="#tab-resumo">Resumo das glosas</v-tab>
        <v-tab-item value="tab-resumo" class="pa-5 pt-0">
          <RankingGlosas
            :selectItem="(item, action) => selectItem(item, action)"
            title="title"
            :dados_pgto="dadosPagamento"
            :list="motivosGlosaList"
            :status="status"
          />
            <!-- <v-row class="px-3 pt-4">
            <v-col cols="12" sm="12" md="12">
                <ChartPie
                :date="data_referencia"
                :list="graficoOrigemGlosa"
                periodo="dia"
                title="title"
                :status="status"
                />
            </v-col>
            <v-col class="pa-0" cols="12" sm="12" md="12">
                <RankingGlosas
                :selectItem="(item, action) => selectItem(item, action)"
                title="title"
                :list="motivosGlosaList"
                :status="status"
                />
            </v-col>
          </v-row> -->
        </v-tab-item>
        <v-tab href="#tab-lotes-vinculados" @click="getLotesPagamento(payload.id, {offset: 1})">Lotes Conciliados</v-tab>
        <v-tab-item value="tab-lotes-vinculados" class="pa-1 pt-9">
          <PagamentoLoteList
            :lotes="lotes"
            :headers="headersConciliados"
            :lotesPagination="lotesPagination"
            :getLotesPagamento="(pagto_id, options)=> getLotesPagamento(payload.id, options)"
            :pagamentoId="payload.id"
          />

          <!-- <v-row class="px-3 pt-4">
                <v-col class="px-0 py-0" cols="12" sm="12" md="4">
                  <h1>Lotes Conciliados</h1>
                  <p  class="mb-0">Lorem ipsum dolor sit amet.</p>
                </v-col>
          </v-row> -->

          <!-- <v-row class="px-3 py-4">
            <v-col class="px-0 py-0" cols="12" xs="12" sm="8" md="4">
              <GenericFilter :filterList="(formData) => filterList(formData)"/>
            </v-col>
          </v-row> -->

          <!-- <v-row class="px-2 pt-3">
              <PagamentoLoteList
                :lotes="lotes"
                :headers="headersConciliados"
                :lotesPagination="lotesPagination"
                :getLotesPagamento="(pagto_id, options)=> getLotesPagamento(payload.id, options)"
              />
          </v-row> -->
        </v-tab-item>
        <!-- <v-tab href="#tab-theme-list">Lotes estratificados</v-tab>
        <v-tab-item value="tab-theme-list" class="pa-0">
              <v-row class="px-3 pt-4">
                <v-col class="px-0 py-0" cols="12" sm="12" md="4">
                      <h1>Lotes estratificados</h1>
                      <p  class="mb-0">Lorem ipsum dolor sit amet.</p>
                </v-col>
                  <v-col class="px-0 py-0" cols="12" sm="12" md="8">
                    <v-row class="ma-0">
                    <v-spacer />
                      <v-btn
                      v-if="userData.PermissaoAcoes.faturamento.includes('addlote')"
                      outlined
                      small
                      height="30px"
                      color="primary"
                      depressed
                      class="px-2 ml-2"
                      @click="showOpen('add_lote')"
                      >Adicionar lote</v-btn>
                      <v-tooltip v-else center bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn small outlined color="primary" height="30px" class="px-2 ml-2" depressed v-bind="attrs" v-on="on">Adicionar lote</v-btn>
                        </template>
                        <span class="px-3 py-1 ma-0" style="border: solid 1px #999; border-radius: 5px; background-color: #FFF;">
                          Você não possui permissão para executar esta ação.
                        </span>
                      </v-tooltip>
                    </v-row>
                  </v-col>
              </v-row>
              <v-row class="px-3 py-4">
                  <v-col class="px-0 py-0" cols="12" xs="12" sm="8" md="4">
                    <GenericFilter :filterList="(formData) => filterList(formData)"/>
                  </v-col>
              </v-row>
              <v-row class="px-3 py-4">
                  <v-col class="px-0 py-0" cols="12">
                     <PagamentoLoteList
                        :dadosPagamento="dadosPagamento"
                        :headers="headersEstratificados"
                        :userData="userData"
                      />
                  </v-col>
              </v-row>
        </v-tab-item> -->
        <v-tab href="#tab-data-publicacao" @click="getHistoricoEventos(payload)">Histórico de eventos</v-tab>
        <v-tab-item value="tab-data-publicacao" class="px-2 pt-9 pb-5">
          <HistoricoPagamentosPublicados :list="historicoList"/>
        </v-tab-item>
      </v-tabs>
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex"
import moment from 'moment'
import PagamentoInfo from '@/components/recebiveis/dados_pagamento/PagamentoInfo'
import PagamentoLoteList from '@/components/recebiveis/dados_pagamento/PagamentoLoteList'
// import GenericFilter from '@/components/recebiveis/dados_pagamento/GenericFilter'
// import ChartPie from '@/components/recebiveis/dados_pagamento/ChartPie'
import RankingGlosas from '@/components/recebiveis/dados_pagamento/RankingGlosas'
import HistoricoPagamentosPublicados from '@/components/recebiveis/dados_pagamento/HistoricoPagamentosPublicados'
export default {
  components: {
    PagamentoInfo,
    PagamentoLoteList,
    // GenericFilter,
    // ChartPie,
    RankingGlosas,
    HistoricoPagamentosPublicados
  },
  filters:{
    formatData(val){
      return  moment(val).format('DD/MM/YYYY')
    },
    formatDateHour(date) {
      return moment(date).format('L') + ' às ' + moment(date).format('LT') + 'h' 
    }
  },
  data() {
    return {
      tab: null,
      payload: {},
      motivosGlosaList: [],
      hasLotesValidos: false,
      total_lotes: 0,
      dadosPagamento: {},
      lotes: {},
      lotesPagination:{
        order: null,
        sort: null,
        limit: 10,
        offset: 0,
        total: 0,
        total_pages: 1
      },
      headersConciliados: [
        { text: 'Arquivo', value: 'arq_nome', class: 'py-0',  sortable: false },
        { text: 'Nº lote', value: 'arq_numero_lote', align: 'left', class: 'py-0', sortable: false },
        { text: 'Data upload', value: 'data_upload', class: 'py-0',sortable: false },
        { text: 'Id prestador', value: 'identificador_prestador', class: 'py-0', sortable: false },
        { text: 'Protocolo', value: 'env_op_protocolo', class: 'py-0', sortable: false },
        { text: 'Nº nota fiscal', value: 'arq_nfs', align: 'left', class: 'py-0', sortable: false },
        { text: 'Vl.apresentado', value: 'valor_informado', align: 'right', class: 'py-0', sortable: false },
        { text: 'Vl.conciliado', value: 'valor_conciliado', align: 'right', class: 'py-0', sortable: false },
        { text: 'Vl.liberado', value: 'valor_liberado', align: 'right', class: 'py-0', sortable: false },
        { text: 'Vl.glosado', value: 'valor_glosado', align: 'right', class: 'py-0', sortable: false},
      ],
      headersEstratificados: [
        { text: 'Demonstrativo', value: 'arq_nome', class: 'py-0',  sortable: false },
        { text: 'Nº lote', value: 'arq_numero_lote', align: 'left', class: 'py-0', sortable: false },
        { text: 'Data upload', value: 'upload_dt', class: 'py-0',sortable: false },
        { text: 'Id prestador', value: 'prestador_id', class: 'py-0', sortable: false },
        { text: 'Protocolo', value: 'protocolo', class: 'py-0', sortable: false },
        { text: 'Vl.apresentado', value: 'arq_vl_calculado', align: 'right', class: 'py-0', sortable: false },
        { text: 'Vl.liberado', value: 'arq_vl_pago', align: 'right', class: 'py-0', sortable: false },
        { text: 'Vl.glosado', value: 'arq_vl_glosado', align: 'right', class: 'py-0', sortable: false},
      ],
      list: [],
      status:{
        'autorizacoes': {text: 'Autorizações', color:'#32b88b'},
        'beneficiarios': {text: 'Beneficiarios', color:'#b2b842'},
        'divergencia_de_valores': {text: 'Divergencia de valores', color:'#fc9d0a'},
        'processo_de_cobranca': {text: 'Processo de cobrança', color:'#fc5f17'},
        'servico_nao_contratado': {text: 'Serviço não contratado', color:'#d0021b'},
        'outros': {text: 'Outros', color:'#4a4a4a'},
        'demais': {text: 'Demais origens', color:'#979797'},
        'demais_motivos': {text: 'Somatório dos demais motivos', color:'#979797'}
      },
      data_referencia: "2021-02-01T00:00:00",
      graficoOrigemGlosa: {
          "autorizacoes": 2141.97,
          "beneficiarios": 1247.56,
          "divergencia_de_valores": 941.05,
          "processo_de_cobranca": 723.67,
          "servico_nao_contratado": 534.88,
          "outros": 423.00,
          "demais": 1897.00
        },
      dados: [
        {
          "operadora_id": 1,
          "autorizacoes": 1,
          "em_analise": 124.56,
          "aguardando_dados_prestador": 2141.05,
          "negadas": 123.67,
          "canceladas": 1234.88,
          "sem_resposta": 123.00,
          "total_glosado": 2345.97
        },
        {
          "operadora_id": 2,
          "autorizacoes": 1,
          "autorizadas_parcialmente": 10,
          "em_analise": 1,
          "aguardando_dados_prestador": 8,
          "negadas": 1,
          "canceladas": 1,
          "sem_resposta": 4,
          "total_solicitacoes": 3
        },
        {
          "operadora_id": 3,
          "autorizacoes": 1,
          "autorizadas_parcialmente": 10,
          "em_analise": 1,
          "aguardando_dados_prestador": 5,
          "negadas": 1,
          "canceladas": 1,
          "sem_resposta": 1,
          "total_solicitacoes": 1
        }
      ],
      historicoList: []
    }
  },
  computed:{
    ...mapState({
      grupoEconomico: state => state.permissions.grupoEconomico,
      userData: (state) => state.userData.userData,
    })
  },
  mounted() {
    let opts = {
      grupo_economico: this.grupoEconomico,
      id: this.$route.params.id,
      pagamento_id: this.$route.params.id
    }
    this.payload = opts
    this.getDetalhesPagamento(opts)
    this.getResumoMotivosGlosa(opts)
  },
  methods: {
    ...mapActions({
      "getDocument":"documents/getDocument"
    }),
    getDetalhesPagamento(payload) {
      let obj = { query:[{modulo: 'Recebiveis', acao: 'getdetalhespagamentopublicado', payload}] }
      this.$store.dispatch("request/doRequest",obj).then(response => { 
        if (!response || response.isAxiosError || !response.sucesso) {
          this.$store.commit("hideLoader")
          return false
        }
        this.dadosPagamento = response
      })
    },
    getResumoMotivosGlosa(payload) {
      let obj = { query:[{modulo: 'Recebiveis', acao: 'getmotivosglosa', payload}] }
      this.$store.dispatch("request/doRequest",obj).then(response => { 
        if (!response || response.isAxiosError || !response.sucesso) {
          this.$store.commit("hideLoader")
          return false
        }
        this.motivosGlosaList = response.dados
      })
    },
    getLotesPagamento(pagamento_id, options) {
      this.lotesPagination = Object.assign(this.lotesPagination, options)
      let  grupo_economico  = this.grupoEconomico
      let obj = {
        query: [
          {
            Modulo: "Recebiveis",
            Acao: "getlotespagamento",
            Payload: { grupo_economico, pagamento_id, ...this.lotesPagination }
          },
        ],
      }
      this.$store.dispatch("request/doRequest", obj).then((response) => {
        if (!response || response.isAxiosError || !response.sucesso) {
          this.$store.commit("hideLoader")
          return
        }
        this.lotes = response
        this.lotesPagination.offset = response.current_page
        this.lotesPagination.total = response.total
        this.lotesPagination.total_pages = response.total_pages
      })
    },
    getHistoricoEventos(payload) {
      let obj = {query:[{Modulo: "Recebiveis", Acao: "gethistoricopagamentospublicados", Payload: payload}]}
      this.$store.dispatch("request/doRequest", obj).then((response) => {
        if (!response || response.isAxiosError || !response.sucesso) {
          this.$store.commit("hideLoader")
          return
        }
        this.historicoList = response.dados
      })
    }
  }
}
</script>

<style>

</style>